__turbopack_context__.v({
  "active": "zMJvva_active",
  "container": "zMJvva_container",
  "error": "zMJvva_error",
  "error-message": "zMJvva_error-message",
  "image": "zMJvva_image",
  "input": "zMJvva_input",
  "label": "zMJvva_label",
  "placeholder": "zMJvva_placeholder",
  "root": "zMJvva_root",
  "two-cols": "zMJvva_two-cols",
});
